import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Card, FormControl, InputGroup, Form, Button } from 'react-bootstrap'
import { RiArrowLeftSLine, RiArrowRightSLine, RiFolderInfoLine } from "react-icons/ri";
import { BsPlusCircleFill } from "react-icons/bs"
import { FaSearch, FaPen, FaCalendarAlt } from "react-icons/fa"
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { Link } from "react-router-dom";
import ReactPaginate from 'react-paginate';


import Get from '../../api/Get'
import Put from '../../api/Put'
import { DOCTOR_LIST, DOCTOR_UPDATE } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import LoadingList from "../../loader/LoadingList";
import SimpleTable from "../../components/SimpleTable";
import '../../styles/doctores/doctores.css'
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever';

function DoctorList({url}){

    //Web service components
    const [pageNo, setPageNo] = useState(0)
    const [pageSize, setPageSize] = useState(20)
    const [sortBy, setSortBy] = useState('name')
    const [name, setName] = useState('%20')
    
    //elements to work
    const [pageCount, setPageCount] = useState(0)
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)
    const [loadData, setLoadData] = useState(true)
    const [filterContent, setFilterContent] = useState('')

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    const {auth} = useContext(authContext)
    let accesToken = auth.data.access_token;

    //Obtener la lista de los doctores
    useEffect(()=>{
        const url = `${DOCTOR_LIST}/${pageNo}/${pageSize}/${sortBy}/${name}`
        setLoading(true)
        Get({url: url, access_token: accesToken})
        .then((resp) => {
            let data = resp.data;
            setItems(data.content ?? [])
            setPageCount(data.totalPages)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [pageNo, pageSize, loadData, name])

    const updateDoctor = item => {
        setLoading(true)

        Put({url: DOCTOR_UPDATE, data: item, header:true, access_token:accesToken})
        .then((resp) => {
            setLoadData(!loadData)
            setLoading(false)
        })                
        .catch((error) => {
            console.log("Error al actualizar el doctor", error)
            setLoading(false)        
        })
    }

    const actions = (cell, row) => {
        return (<div key={`acciones-${row?.id}`}>
                <ul key={row?.id} className="list-inline mb-0">
                    <li className="list-inline-item">
                        <Link to={`${url}/create?id=${row.id}`}>
                            <FaPen className='iconAction colorNaranja' />
                        </Link>
                    </li>          
                    <li className="list-inline-item">
                        <Link to={`${url}/doctoragenda/${row.id}`}>
                            <FaCalendarAlt className='iconAction colorVerde' />
                        </Link>
                    </li>          
                    <li className="list-inline-item">
                        <BootstrapSwitchButton
                            checked={row.active} 
                            onlabel="Activo"
                            onstyle="success"
                            offlabel="Inactivo"
                            offstyle="danger"
                            width={69}
                            size="sm"
                            onChange={ (value)=>updateDoctor({...row, "active":value}) }
                        />
                    </li>
                    <li className="list-inline-item"><Link to={`${url}/trazabilidad/${row.id}`}><RiFolderInfoLine className='iconAction colorRojo'/></Link></li>
                </ul>          

        </div>
        );
    }

    const especiality = (cel, row) => {
        let output = ""
        
        row?.specialties.map((e) => {
            if(output !== "")
                output += ", "

            output += `${e?.especialty?.name}`
        });

        return output;
    }

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            headerStyle: { width: '10%' },
            hidden:true
        }, 
        {
            dataField: 'name',
            text: 'NOMBRE',
            headerStyle: { width: '20%' },
            formatter: (cell, row) => `${row.name} ${row.lastName}`,
        }, 
        {
            dataField: '',
            isDummyField: true,
            text: 'ESPECIALIDAD',
            headerStyle: { width: '20%' },
            formatter: especiality,
        }, 
        {
            dataField: 'email',
            text: 'CORREO ELECTRÓNICO',
            headerStyle: { width: '20%' },
        }, 
        {
            dataField: '-',
            isDummyField: true,
            text: 'ACCIONES',
            headerStyle: { width: '30%' },
            formatter: actions,
        }
    ]

    const handlePageClick = (data) => setPageNo(data.selected);
    const handleSearchChange = (e) => setFilterContent(e.target.value)
    const handleNameChannge = (e) => {
        e.preventDefault()
        setName(filterContent===''?'%20':filterContent)
    }

    return (<>
        {loading && <LoadingList />}
        <div className='body'>
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">Doctores</h2>
                </Col>
                <Col xs="12" md="4">
                    <Row className="align-items-center">
                        <Col xs="8" md="9">
                            <Form onSubmit={handleNameChannge}>
                                <InputGroup>
                                    <FormControl
                                        type="text"
                                        value={filterContent}
                                        onChange={handleSearchChange}
                                        placeholder="Buscar"
                                        className="input-1"
                                    />
                                    <InputGroup.Append>
                                        <Button type="submit" variant="outline-secondary" className="input-span-1"><FaSearch/></Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            </Form>
                        </Col>
                        <Col xs="4" md="3">
                            <Link to={`${url}/create`}><BsPlusCircleFill className="add-btn"/></Link>                        
                        </Col>
                    </Row>                
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card className="shadow-1 mt-3">
                        <Card.Body>
                            <SimpleTable 
                                columns={columns} 
                                items={items}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col xs="12" md="10">
                    <ReactPaginate
                        previousLabel={<RiArrowLeftSLine />}
                        nextLabel={<RiArrowRightSLine />}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                </Col>
                <Col className="d-none d-md-block" xs="12" md="2">
                    <select className="select-pagin" onChange={e=>setPageSize(e.target.value)}>
                        <option value="20">20 / página</option>
                        <option value="30">30 / página</option>
                        <option value="50">50 / página</option>
                    </select>
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
    </>)
}

export default DoctorList